import { useStore } from '@store/index';

import { type FiltersConfig, getFiltersConfigForWorkflowType } from '@/config/quickFilters.config';
import { WorkflowType } from '@/constants/dispositions';

/**
 * Hook to get the active filters configuration based on the selected workflow type.
 * Returns workflow-specific config if one exists, or the default config otherwise.
 */
export function useActiveFiltersConfig(): FiltersConfig {
  const { getSelectedWorkflow } = useStore();
  const selectedWorkflow = getSelectedWorkflow();

  return getFiltersConfigForWorkflowType(selectedWorkflow?.workflow_type as WorkflowType);
}
